export const abtastyJsId = process.env.NEXT_PUBLIC_ABTASTY_JS_ID;
export const clarityTagId = process.env.NEXT_PUBLIC_CLARITY_TAG_ID;
export const facebookPixelId = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;
export const googleAnalyticsTagId = (
  process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_TAG_ID
);
export const googleTagManagerId = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;
export const dynamicYieldSectionId = (
  process.env.NEXT_PUBLIC_DYNAMIC_YIELD_SECTION_ID
);
export const dyLiveApiKey = (
  process.env.DY_API_KEY
);
export const teadsTagId = process.env.NEXT_PUBLIC_TEADS_TAG_ID;
export const teadsId = process.env.NEXT_PUBLIC_TEADS_ID;
export const andbeyondId = process.env.NEXT_PUBLIC_ANDBEYOND_ID;
export const eyeotaPid = process.env.NEXT_PUBLIC_EYEOTA_PID;
